<template lang='pug'>
  #dual-input(:class="{ 'dual-input-danger' : danger}")
    label#left-label {{ leftLabel }}
    input#left-input(type='number' name='left' :disabled='disabled || disabledLeft' :value="leftValue" @input="leftValue = parseInt($event.target.value)" v-debounce:450ms.lock="emitValue" :debounce-events="'input'" :tabindex="idx + 1" :min="0" :max="max")
    label#right-label {{ rightLabel }}
    input#right-input(type='number' name='right' :disabled='disabled || disabledRight' :value="rightValue" @input="rightValue = parseInt($event.target.value)" v-debounce:450ms.lock="emitValue" :debounce-events="'input'" :tabindex="idx + 2" min="0")
</template>

<script>
export default {
  name: 'DualInput',
  props: {
    leftLabel: {
      type: String,
      default: 'Done'
    },
    rightLabel: {
      type: String,
      default: 'Total'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledRight: {
      type: Boolean,
      default: false
    },
    disabledLeft: {
      type: Boolean,
      default: false
    },
    data: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: () => {}
    },
    idx: {
      type: Number
    },
    resetVal: {
      type: Boolean
    }
  },
  data: () => ({
    leftValue: 0,
    rightValue: 0
  }),
  created () {
    this.setInputValues(this.data)
  },
  computed: {
    danger () {
      return this.leftValue > this.rightValue
    }
  },
  methods: {
    emitValue () {
      this.$emit('input', { val: this.leftValue, limit: this.max, scope_id: this.item.id, idx: this.idx })
    },
    setInputValues (val) {
      this.leftValue = 0
      this.rightValue = val
    }
  },
  watch: {
    resetVal (bool) {
      if (bool) {
        this.leftValue = 0
      }
      this.$emit('reset')
    },
    data (value) {
      if (value) this.setInputValues(value)
    }
  }
}
</script>
<style lang='scss' scoped>
.dual-input-danger {
  label {
    color: red !important;
  }
  #left-input {
    border: 1px solid red !important;
  }
  #right-input {
     border: 1px solid red !important;
  }
}
#dual-input {
  max-width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  label {
    position: absolute;
    top: -8px;
    background: white;
    border-radius: 5px;
    padding: 0 10px;
    font-size: 11px;
    user-select: none;
    pointer-events: none;
  }
  #left-label {
    left: 15%;
  }
  #right-label {
    right: 15%;
  }
  input {
    padding: 8px 10px;
    width: 100%;
    font-size: 16px;
  }
  #left-input {
    border: 1px solid rgb(168, 168, 168);
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-right: 0;
  }
  #right-input {
    border: 1px solid rgb(168, 168, 168);
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
</style>
